module.exports = __webpack_public_path__ + "img/jyzt-icon1.5a748530.png";